<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4"></div>
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-md-6" v-for="option in mini_dashboard_options" :key="option.name">
          <stats-card-custom :title="option.name" :sub-title="option.count" :sub-title-suffix="total_tasks"
            :backgroundColor="option.color" :legendBackgroundColor="option.legend_color" :legend="option.percent + '%'">
          </stats-card-custom>
        </div>

        <!-- <div class="col-xl-3 col-md-6">
          <stats-card-custom
            title="IN PROGRESS"
            :sub-title="option_2.count"
            :sub-title-suffix="total_tasks"
            backgroundColor="success"
            :legend="option_2.percent + '%'"
          >
          </stats-card-custom>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card-custom
            title="VENDOR INFORMED"
            :sub-title="option_3.count"
            :sub-title-suffix="total_tasks"
            backgroundColor="info"
            :legend="option_3.percent + '%'"
          >
          </stats-card-custom>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card-custom
            title="PENDING QUOTATION"
            :sub-title="option_4.count"
            :sub-title-suffix="total_tasks"
            backgroundColor="warning"
            :legend="option_4.percent + '%'"
          >
          </stats-card-custom>
        </div> -->
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                <h5 class="h3 mb-0">Overview</h5>
              </div>
            </div>
            <doughnut-chart :height="350" :chart-data="operationalChart.chartData"
              :extra-options="operationalChart.extraOptions" v-if="operationalChart.chartData">
            </doughnut-chart>
            <div v-else style="height:350px" class="text-center">
              <div class="no-data">No data available for chart yet</div>
            </div>
          </card>
        </div>

        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                <h5 class="h3 mb-0">DRI</h5>
              </div>
            </div>
            <doughnut-chart :height="350" :chart-data="driChart.chartData" :extra-options="driChart.extraOptions"
              v-if="driChart.chartData">
            </doughnut-chart>
            <div v-else style="height:350px" class="text-center">
              <div class="no-data">No data available for chart yet</div>
            </div>
          </card>
        </div>
        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                <h5 class="h3 mb-0">Progress</h5>
              </div>
            </div>

            <bar-chart :height="350" ref="barChart" :chart-data="statusChart.chartData"
              :extra-options="statusChart.extraOptions" v-if="statusChart.chartData">
            </bar-chart>
            <div v-else style="height:350px" class="text-center">
              <div class="no-data">No data available for chart yet</div>
            </div>
          </card>
        </div>
        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                <h5 class="h3 mb-0">Past Due</h5>
              </div>
            </div>

            <bar-chart :height="350" ref="barChart" :chart-data="pastDueChart.chartData"
              :extra-options="pastDueChart.extraOptions" v-if="pastDueChart.chartData">
            </bar-chart>
            <div v-else style="height:350px" class="text-center">
              <div class="no-data">No data available for chart yet</div>
            </div>
          </card>
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";
import DoughnutChart from "@/components/Charts/DoughnutChart";
import { Charts } from "@/components/Charts/config";

import store from "@/store";
import moment from "moment";

function getBoardItems(id) {
  return store.dispatch("monday/list_board_items", { id });
}

const MATTERS_ARISING_BOARD_ID = process.env.VUE_APP_MATTERS_ARISING_BOARD_ID; //528598435;
const PROCUREMENT_BOARD_ID = process.env.VUE_APP_PROCUREMENT_BOARD_ID; //528614366;

const MINI_DASHBOARD_OPTION_1 = "new item";
const MINI_DASHBOARD_OPTION_2 = "in progress";
const MINI_DASHBOARD_OPTION_3 = "vendor informed";
const MINI_DASHBOARD_OPTION_4 = "pending quotation";

export default {
  components: {
    BarChart,
    DoughnutChart
  },
  data() {
    return {
      mini_dashboard_options: [
        {
          name: "new item",
          color: "#f5365c",
          legend_color: "#D32749",
          count: 0,
          percent: 0
        },
        {
          name: "in progress",
          color: "#33AADB",
          legend_color: "#2189B4",
          count: 0,
          percent: 0
        },
        {
          name: "vendor informed",
          color: "#5CB85C",
          legend_color: "#408E40",
          count: 0,
          percent: 0
        },
        {
          name: "pending quotation",
          color: "#FFBA00",
          legend_color: "#DCA510",
          count: 0,
          percent: 0
        }
      ],
      board_items: [],
      loader: null,
      matters_arising: [], // board renamed to outstanding list
      total_tasks: 0,
      past_due_open: 0,
      progress_types: [],
      detail_types: [],
      operationalChart: {},
      statusChart: {},
      pastDueChart: {},
      driChart: {}
    };
  },
  methods: {
    updateOperationalChart() {
      let progress_type_percentages = [];
      let progress_types = [];
      let progress_colors = [];
      let board_items = this.matters_arising.items;
      let total_items = board_items.length;
      let gray_index = 500;

      let grouped_by_progress = _.groupBy(board_items, _item => {
        return _item.progress;
      });

      this.total_tasks = board_items.length;

      // progress names. ie: Monitoring, MA, Council...
      for (let key in grouped_by_progress) {
        if (key !== "/") {
          progress_types.push(key);
          // color for each progress pie
          let colorKey = key.toLowerCase();
          let progress_color = Charts.colors.progress[colorKey];
          if (!progress_color) {
            progress_color = Charts.colors.gray[gray_index];
            gray_index += 100;
          }
          progress_colors.push(progress_color);

          // percentages for each progress pie
          let percentage = Math.round(
            (grouped_by_progress[key].length / total_items) * 100
          );
          progress_type_percentages.push(percentage);

          let option = _.find(
            this.mini_dashboard_options,
            opt => opt.name == key.toLowerCase()
          );
          if (option) {
            (option.count = grouped_by_progress[key].length),
              (option.percent = percentage);
          }
        }
      }

      this.operationalChart = {
        chartData: {
          labels: progress_types,
          datasets: [
            {
              data: progress_type_percentages,
              backgroundColor: progress_colors
            }
          ]
        },
        extraOptions: {
          responsive: true,
          legend: {
            display: true,
            position:
              document.documentElement.clientWidth <= 768 ? "bottom" : "right"
          },
          animation: {
            animateScale: true,
            animateRotate: true,
            duration: document.documentElement.clientWidth <= 768 ? 0 : 1000
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.labels[tooltipItem.index] || "";
                if (label) {
                  label +=
                    ": " + data.datasets[0].data[tooltipItem.index] + "%";
                }
                return label;
              }
            }
          }
        }
      };
    },
    updateProgressChart() {
      // progress col
      let progress_data = [];
      let progress_types = [];
      let dataset = [];

      let board_items = this.matters_arising.items;
      let grouped_by_progress = _.groupBy(board_items, _item => {
        return _item.progress;
      });
      // status names. ie: open, hold, pending..
      for (let key in grouped_by_progress) {
        progress_types.push(key);
      }

      let grouped_by_detail = _.groupBy(board_items, _item => {
        return _item.detail;
      });

      // tabulate status counter for each detail type
      let items = [];
      let counter = [];
      let len = 0;
      for (let key in grouped_by_detail) {
        items = grouped_by_detail[key];
        counter = [];

        for (let i = 0; i < progress_types.length; i++) {
          let type = progress_types[i];
          len = _.filter(items, _item => {
            return _item.progress == type;
          }).length;
          counter[type] = len;
        }
        let d = {};
        d.detail = key;
        d.counter = counter;
        dataset.push(d);
      }

      // construct data for chart based on chartjs required format
      let data = [];
      let gray_index = 500;
      for (let i = 0; i < progress_types.length; i++) {
        let type = progress_types[i];
        data = [];
        dataset.map(d => {
          data.push(d.counter[type]);
        });

        let label = type ? type : "empty";
        let color = Charts.colors.progress[label.toLowerCase()];
        if (!color) {
          color = Charts.colors.gray[gray_index]; // use gray
          gray_index += 100;
        }

        progress_data.push({
          label: label,
          backgroundColor: color,
          data: data
        });
      }

      this.statusChart = {
        chartData: {
          labels: this.detail_types,
          datasets: progress_data
        },
        extraOptions: {
          legend: {
            display: true,
            position:
              document.documentElement.clientWidth <= 768 ? "bottom" : "right"
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: "No. of tasks"
                }
              }
            ]
          },
          animation: {
            duration: document.documentElement.clientWidth <= 768 ? 0 : 1000
          }
        }
      };
    },
    updatePastDueChart() {
      let progress_type_labels = [];
      let progress_data = [];
      let progress_types = [];

      let board_items = this.matters_arising.items;
      let total_items = board_items.length;

      let grouped_by_progress = _.groupBy(board_items, _item => {
        return _item.progress;
      });
      // status names. ie: open, hold, pending..
      for (let key in grouped_by_progress) {
        progress_types.push(key);
      }

      let pastDueData = _.filter(this.matters_arising.items, r => {
        return progress_types.includes(r.progress);
      });

      // tabulate status counter for each progress type
      let past_due_open = 0;
      let dataset = [];
      let items = [];
      let counter = [];
      let type;
      let len = 0;
      const DATE_FORMAT = "DD MMM YYYY";

      for (let key in grouped_by_progress) {
        items = grouped_by_progress[key];
        counter = [];
        for (let i = 0; i < progress_types.length; i++) {
          type = progress_types[i];
          len = 0;
          len = _.filter(items, _item => {
            if (
              _item.due_date &&
              moment(_item.due_date, DATE_FORMAT).isValid()
            ) {
              // console.log(_item.due_date);
              return (
                moment(_item.due_date, DATE_FORMAT).isBefore(moment.now()) &&
                _item.progress == type
              );
            }
          }).length;

          counter[type] = len;
        }

        progress_type_labels.push(key);
        let d = {};
        d.detail = key; // administration, contract, maintenance...
        d.counter = counter; // { open: 0, hold: 2 }
        dataset.push(d);
      }

      // construct data for chart based on chartjs required format
      let gray_index = 500;
      for (let i = 0; i < progress_types.length; i++) {
        let type = progress_types[i];
        let data = [];
        dataset.map(d => {
          data.push(d.counter[type]);
        });

        let color = Charts.colors.progress[type.toLowerCase()];
        if (!color) {
          color = Charts.colors.gray[gray_index]; // use gray
          gray_index += 100;
        }

        progress_data.push({
          label: type,
          backgroundColor: color,
          data: data,
          maxBarThickness: 32
        });
      }

      this.pastDueChart = {
        chartData: {
          labels: progress_type_labels,
          datasets: progress_data
        },
        extraOptions: {
          legend: {
            display: true,
            position:
              document.documentElement.clientWidth <= 768 ? "bottom" : "right"
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: "No. of tasks"
                }
              }
            ]
          },
          animation: {
            duration: document.documentElement.clientWidth <= 768 ? 0 : 1000
          }
        }
      };
    },
    updateDriChart() {
      let dri_type_percentages = [];
      let dri_types = [];
      let dri_colors = [];
      let board_items = this.matters_arising.items;
      let total_items = board_items.length;
      let gray_index = 500;

      let grouped_by_dri = _.groupBy(board_items, _item => {
        return _item.detail;
      });
      // dri names. ie: council, site, contract...
      for (let key in grouped_by_dri) {
        if (key !== "/") {
          dri_types.push(key);
          // color for each dri pie
          let colorKey = key.toLowerCase();
          let dri_color = Charts.colors.dri[colorKey];
          if (!dri_color) {
            dri_color = Charts.colors.gray[gray_index];
            gray_index += 100;
          }
          dri_colors.push(dri_color);

          // percentages for each dri pie
          let percentage = Math.round(
            (grouped_by_dri[key].length / total_items) * 100
          );
          dri_type_percentages.push(percentage);
          if (key.toLowerCase() == MINI_DASHBOARD_OPTION_3) {
            this.dri.count = grouped_by_dri[key].length;
            this.dri.percent = percentage;
          }
        }
      }

      this.driChart = {
        chartData: {
          labels: dri_types,
          datasets: [
            {
              data: dri_type_percentages,
              backgroundColor: dri_colors
            }
          ]
        },
        extraOptions: {
          responsive: true,
          legend: {
            display: true,
            position:
              document.documentElement.clientWidth <= 768 ? "bottom" : "right"
          },
          animation: {
            animateScale: true,
            animateRotate: true,
            duration: document.documentElement.clientWidth <= 768 ? 0 : 1000
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.labels[tooltipItem.index] || "";
                if (label) {
                  label +=
                    ": " + data.datasets[0].data[tooltipItem.index] + "%";
                }
                return label;
              }
            }
          }
        }
      };
    }
  },
  computed: {
    store_board_items() {
      return store.state.monday.board_items;
    }
  },
  watch: {
    store_board_items(newBoardItems, oldBoardItems) {
      this.board_items = newBoardItems;
    }
  },
  mounted() {
    // load board items
    this.board_items = this.store_board_items;
    getBoardItems(MATTERS_ARISING_BOARD_ID).then(() => {
      // let board_groups = MATTERS_ARISING_BOARD_GROUPS; // use these groups for charts

      this.matters_arising = store.state.monday.board_items.find(
        item => item.id == MATTERS_ARISING_BOARD_ID
      );

      // let grouped_by_progress = _.groupBy(this.matters_arising.items, _item => {
      //   return _item.progress;
      // });
      // // progress names. ie: Monitoring, MA, Council...
      // for (let key in grouped_by_progress) {
      //   // 2020-10-19 hide "/" progress (closed)
      //   if (key !== "/") this.progress_types.push(key);
      // }

      let grouped_by_detail = _.groupBy(this.matters_arising.items, _item => {
        return _item.detail;
      });
      // detail. ie: administration, contract, maintenance...
      for (let key in grouped_by_detail) {
        this.detail_types.push(key);
      }

      this.updateOperationalChart();
      this.updateProgressChart();
      this.updatePastDueChart();
      this.updateDriChart();
    });
  }
};
</script>
<style lang="scss" scoped>
.text-align-right {
  text-align: right;
}

.no-data {
  padding: 50px 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
